import { render, staticRenderFns } from "./NosotrosView.vue?vue&type=template&id=633f4017&"
import script from "./NosotrosView.vue?vue&type=script&lang=js&"
export * from "./NosotrosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports